import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderAdvent from "../../../../src/content/advent/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderAdvent,
  React
};